
export const PRIVACY__SET_PRIVACY_ID = 'PRIVACY__SET_PRIVACY_ID';
export const PRIVACY__ADD_FILE = 'PRIVACY__ADD_FILE';
export const PRIVACY__CLEAR_PRIVACY = 'PRIVACY__CLEAR_PRIVACY';
export const PRIVACY__SET_LOCALE_OPTIONS = 'PRIVACY__SET_LOCALE_OPTIONS';
export const PRIVACY__SET_FILE_LOCALE = 'PRIVACY__SET_FILE_LOCALE';
export const PRIVACY__REMOVE_FILE = 'PRIVACY__REMOVE_FILE';
export const PRIVACY__SET_PRIVACY_VALUE = 'PRIVACY__SET_PRIVACY_VALUE';
export const PRIVACY__SET_PRIVACY = 'PRIVACY__SET_PRIVACY';

export const GET_LOCALES = 'API_FETCH__GET_LOCALES';
export const GET_PRIVACY_FILES = 'API_FETCH__GET_PRIVACY_FILES';
